import {DoppeAllSupportedPremiumFeatures, DoppeAllSupportedPremiumFeaturesSpec} from './doppe-premium.auto-generated';
import {evaluateFunction, objectPick, Values} from '@wix/devzai-utils-common';
import {DoppeDtoPremiumFeatureCatalogInfo} from '../types';

export const DoppeFreeToolsLimit = {
    LandingPages: 1,
    PreRolls: 0,
    ShortLinks: 0,
}

const implementedPremiumFeatures = [
    DoppeAllSupportedPremiumFeatures.hopp_remove_banner,
    DoppeAllSupportedPremiumFeatures.hopp_latest_items_action,
    DoppeAllSupportedPremiumFeatures.hopp_verified_badge,
    DoppeAllSupportedPremiumFeatures.hopp_advanced_page_presets,
    DoppeAllSupportedPremiumFeatures.hopp_list_premium_styles,
    DoppeAllSupportedPremiumFeatures.hopp_phone_number_collection,
    DoppeAllSupportedPremiumFeatures.hopp_add_items_to_list_action,
    DoppeAllSupportedPremiumFeatures.hopp_create_short_links,
    DoppeAllSupportedPremiumFeatures.hopp_indexed_links_in_search,
    DoppeAllSupportedPremiumFeatures.hopp_full_analytics,
    DoppeAllSupportedPremiumFeatures.hopp_allow_landing_pages,
    DoppeAllSupportedPremiumFeatures.hopp_allow_pre_rolls,
    DoppeAllSupportedPremiumFeatures.hopp_contact_management,
    DoppeAllSupportedPremiumFeatures.hopp_crm_integration_wix,
    DoppeAllSupportedPremiumFeatures.hopp_advanced_design_options,
    DoppeAllSupportedPremiumFeatures.connect_your_domain,
    DoppeAllSupportedPremiumFeatures.hopp_seo_settings,
    DoppeAllSupportedPremiumFeatures.hopp_social_share_settings_editing,
    DoppeAllSupportedPremiumFeatures.hopp_google_analytics,
    DoppeAllSupportedPremiumFeatures.creators_favicon_,
    DoppeAllSupportedPremiumFeatures.hopp_unlimited_pages,
    DoppeAllSupportedPremiumFeatures.hopp_allow_short_links,
    DoppeAllSupportedPremiumFeatures.media_storage_total,
    DoppeAllSupportedPremiumFeatures.creators_advanced_search_settings,
    DoppeAllSupportedPremiumFeatures.hopp_full_screen_view,
    DoppeAllSupportedPremiumFeatures.creators_monetization_actions,
    DoppeAllSupportedPremiumFeatures.creators_form_submission,
    DoppeAllSupportedPremiumFeatures.vip_support,
    DoppeAllSupportedPremiumFeatures.identity_collaborators,
    DoppeAllSupportedPremiumFeatures.creators_pre_rolls_count,
] satisfies DoppeAllSupportedPremiumFeatures[];

export const DoppePremiumFeatures = objectPick(DoppeAllSupportedPremiumFeatures, implementedPremiumFeatures);
export type DoppePremiumFeatures = Values<typeof DoppePremiumFeatures>;

export const DoppePremiumFeaturesAlias = {
    editSocialShareSettings: DoppePremiumFeatures.hopp_social_share_settings_editing,
    importLinks: DoppePremiumFeatures.hopp_advanced_design_options,
}

export const DoppePremiumFeaturesSpec = objectPick(DoppeAllSupportedPremiumFeaturesSpec, implementedPremiumFeatures);

export const DoppePagePremiumFeatures = {
    RemoveBanner: 'RemoveBanner',
    VerifiedBadge: 'VerifiedBadge',
    ProLayout: 'ProLayout',
    ProListLayout: 'ProListLayout',
    LatestItemsInLists: 'LatestItemsInLists',
    LatestBlogPostsInLists: 'LatestBlogPostsInLists',
    LatestProductsInLists: 'LatestProductsInLists',
    UpcomingEventsInLists: 'UpcomingEventsInLists',
    LatestBookingServicesInLists: 'LatestBookingServicesInLists',
    ListItemsLimit: 'PageListItemsLimit',
    PhoneNumberCollection: 'PhoneNumberCollection',
    ProButtonStyle: 'ProButtonStyle',
    ProActionDisplay: 'ProActionDisplay',
    ProFont: 'ProFont',
    ConnectToContactsList: 'ConnectToContactsList',
    AdvancedSearchSettings: 'AdvancedSearchSettings',
    ShowAsPopup: 'ShowAsPopup',
    SeoSettings: 'SeoSettings',
    SocialShare: 'SocialShare',
    GoogleAnalytics: 'PageGoogleAnalytics',
    ShowListItemAsPopup: 'ShowListItemAsPopup',
    FormActions: 'FormActions',
    PaymentActions: 'PaymentActions',
} as const;

export type DoppePagePremiumFeatures = Values<typeof DoppePagePremiumFeatures>;


export const DoppePageNoneViolatedPremiumFeatures = {
    ListItemsLimit: 'ListItemsLimit',
    SearchItemsLimit: 'SearchItemsLimit',
} as const;

export type DoppePageNoneViolatedPremiumFeatures = Values<typeof DoppePageNoneViolatedPremiumFeatures>;

export const DoppeBehaviourPremiumFeatures = {
    EditLandingPage: 'EditLandingPage',
    ManageLandingPage: 'ManageLandingPage',
    DuplicateLandingPage: 'DuplicateLandingPage',
    CreateLandingPages: 'CreateLandingPages',
    EditPreRoll: 'EditPreRoll',
    DuplicatePreRoll: 'DuplicatePreRoll',
    ManagePreRoll: 'ManagePreRoll',
    CreatePreRolls: 'CreatePreRolls',
    CreateShortLinks: 'CreateShortLinks',
    ManageShortLinks: 'ManageShortLinks',
    EditShortLinks: 'EditShortLinks',
    ImportShortLinks: 'ImportShortLinks',
    ImportShortLinksFromYoutube: 'ImportShortLinksFromYoutube',
    EditSocialShare: 'EditSocialShare',
    EditSeoSettings: 'EditSeoSettings',
    EditFaviconSettings: 'EditFaviconSettings',
    CreateNewSubscribeList: 'CreateNewSubscribeList',
    ExportContacts: 'ExportContacts',
    ConnectCRM: 'ConnectCRM',
    UpgradeCRM: 'UpgradeCRM',
    SocialLinksAnalytics: 'SocialLinksAnalytics',
    GoogleAnalytics: 'GoogleAnalytics',
    ConnectDomain: 'ConnectDomain',
    ConnectSubdomain: 'ConnectSubdomain',
    MediaStorage: 'MediaStorage',
    VIPSupport: 'VIPSupport',
} as const;

export type DoppeBehaviourPremiumFeatures = Values<typeof DoppeBehaviourPremiumFeatures>;

export const DoppeUpgradeRequiringPremiumFeatures = {
    ...DoppePagePremiumFeatures,
    ...DoppePageNoneViolatedPremiumFeatures,
    ...DoppeBehaviourPremiumFeatures
}

export type DoppeUpgradeRequiringPremiumFeatures =
    | DoppePagePremiumFeatures
    | DoppePageNoneViolatedPremiumFeatures
    | DoppeBehaviourPremiumFeatures;


export function getPremiumFeatureNameFromDoppePremiumFeature(premiumFeature: DoppeUpgradeRequiringPremiumFeatures) : DoppeAllSupportedPremiumFeatures   {

    const relatedFeature = evaluateFunction(() => {
        switch (premiumFeature) {
            case DoppePageNoneViolatedPremiumFeatures.SearchItemsLimit: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_indexed_links_in_search
            }
            case DoppePagePremiumFeatures.AdvancedSearchSettings: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.creators_advanced_search_settings
            }
            case DoppeBehaviourPremiumFeatures.ExportContacts:
            case DoppePagePremiumFeatures.ConnectToContactsList:
            case DoppeBehaviourPremiumFeatures.CreateNewSubscribeList:
            case DoppeBehaviourPremiumFeatures.UpgradeCRM:
            case DoppeBehaviourPremiumFeatures.ConnectCRM: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_contact_management
            }
            case DoppeBehaviourPremiumFeatures.ConnectDomain: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.connect_your_domain
            }
            case DoppeBehaviourPremiumFeatures.ConnectSubdomain: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_allow_connect_subdomain
            }
            case DoppeBehaviourPremiumFeatures.ManageLandingPage:
            case DoppeBehaviourPremiumFeatures.EditLandingPage:
            case DoppeBehaviourPremiumFeatures.DuplicateLandingPage:
            case DoppeBehaviourPremiumFeatures.CreateLandingPages: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_unlimited_pages,
            }
            case DoppeBehaviourPremiumFeatures.ManagePreRoll:
            case DoppeBehaviourPremiumFeatures.EditPreRoll:
            case DoppeBehaviourPremiumFeatures.DuplicatePreRoll:
            case DoppeBehaviourPremiumFeatures.CreatePreRolls: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.creators_pre_rolls_count,
            }

            case DoppeBehaviourPremiumFeatures.ManageShortLinks:
            case DoppeBehaviourPremiumFeatures.EditShortLinks:
            case DoppeBehaviourPremiumFeatures.CreateShortLinks: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_create_short_links,
            }
            case DoppeBehaviourPremiumFeatures.ImportShortLinks: return {
                // uniqueName: DoppeAllSupportedPremiumFeatures.hopp_import_links_from_youtube
                uniqueName: DoppePremiumFeaturesAlias.importLinks
            }
            case DoppeBehaviourPremiumFeatures.ImportShortLinksFromYoutube: return {
                // uniqueName: DoppeAllSupportedPremiumFeatures.hopp_import_links_from_youtube
                uniqueName: DoppePremiumFeaturesAlias.importLinks
            }
            case DoppeBehaviourPremiumFeatures.EditFaviconSettings: return {
                // uniqueName: DoppeAllSupportedPremiumFeatures.creators_favicon_
                uniqueName: DoppePremiumFeatures.creators_favicon_
            }
            case DoppePagePremiumFeatures.SeoSettings:
            case DoppeBehaviourPremiumFeatures.EditSeoSettings: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_seo_settings
            }
            case DoppePagePremiumFeatures.SocialShare:
            case DoppeBehaviourPremiumFeatures.EditSocialShare: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_social_share_settings_editing
            }
            case DoppePagePremiumFeatures.GoogleAnalytics:
            case DoppeBehaviourPremiumFeatures.GoogleAnalytics: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_google_analytics
            }
            case DoppePagePremiumFeatures.LatestBlogPostsInLists:
            case DoppePagePremiumFeatures.LatestProductsInLists:
            case DoppePagePremiumFeatures.UpcomingEventsInLists:
            case DoppePagePremiumFeatures.LatestBookingServicesInLists:
            case DoppePagePremiumFeatures.LatestItemsInLists: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_latest_items_action
            }
            case DoppePageNoneViolatedPremiumFeatures.ListItemsLimit:
            case DoppePagePremiumFeatures.ListItemsLimit: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_add_items_to_list_action
            }
            case DoppePagePremiumFeatures.PhoneNumberCollection: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_phone_number_collection
            }
            case DoppePagePremiumFeatures.ShowListItemAsPopup:
            case DoppePagePremiumFeatures.ProLayout:
            case DoppePagePremiumFeatures.ProFont:
            case DoppePagePremiumFeatures.ProActionDisplay:
            case DoppePagePremiumFeatures.ProButtonStyle: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_advanced_design_options
            }
            case DoppePagePremiumFeatures.ShowAsPopup: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_full_screen_view
            }
            case DoppePagePremiumFeatures.ProListLayout: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_list_premium_styles
            }
            case DoppePagePremiumFeatures.RemoveBanner: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_remove_banner
            }
            case DoppeBehaviourPremiumFeatures.SocialLinksAnalytics: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_full_analytics
            }
            case DoppePagePremiumFeatures.VerifiedBadge: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.hopp_verified_badge
            }
            case DoppePagePremiumFeatures.FormActions: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.creators_form_submission
            }
            case DoppePagePremiumFeatures.PaymentActions: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.creators_monetization_actions
            }
            case DoppeBehaviourPremiumFeatures.MediaStorage: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.media_storage_total
            }
            case DoppeBehaviourPremiumFeatures.VIPSupport: return {
                uniqueName: DoppeAllSupportedPremiumFeatures.vip_support
            }
        }
    })

    return relatedFeature.uniqueName;
}
export function convertPremiumFeaturetoPremiumFeatureCatalogInfo(premiumFeature: DoppeAllSupportedPremiumFeatures , quota?: number) : DoppeDtoPremiumFeatureCatalogInfo   {

    const limit = {
        low: quota ?? 0,
        high: 0,
        unsigned: false,
    }

    return {
        type: DoppeAllSupportedPremiumFeaturesSpec[premiumFeature],
        uniqueName: premiumFeature,
        limit: limit
    }
}


export function getPremiumFeatureFromDoppePremiumFeature(premiumFeature: DoppeUpgradeRequiringPremiumFeatures , quota?: number) : DoppeDtoPremiumFeatureCatalogInfo {
    return convertPremiumFeaturetoPremiumFeatureCatalogInfo(getPremiumFeatureNameFromDoppePremiumFeature(premiumFeature), quota);
}

export function isPremiumActionFeature(premiumFeature: DoppePagePremiumFeatures): boolean {
    return premiumFeature === DoppePagePremiumFeatures.PaymentActions || premiumFeature === DoppePagePremiumFeatures.FormActions;
}

